



















































import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class ArtistsList extends Vue {
    loader = true
    pageOffset = 0
    pageOffsetAlt = 0
    clicks = 1
    pageOffsetMonth = 0
    pageOffsetAltMonth = 0
    clicksMonth = 1
    view = 'total'
    error = null

    get artistTotal () {
        return this.$store.getters['artistModule/getArtistsTotal']
    }

    get artistMonth () {
        return this.$store.getters['artistModule/getArtistsMonth']
    }

    pageNext () {
        this.pageOffset += 16
        this.loader = true
        this.$store.dispatch('artistModule/fetchPagesForTopArtists', this.pageOffset).then(()=> {
            this.loader = false
            window.scrollTo(0,0);
            this.clicks ++;
            this.pageOffsetAlt += 16
        })
    }
    pageBack () {
        this.loader = true
        this.pageOffset -= 16
        this.$store.dispatch('artistModule/fetchPagesForTopArtists', this.pageOffset).then(() => {
            this.loader = false
            window.scrollTo(0,0);
            this.clicks --;
            this.pageOffsetAlt -= 16
        })
    }

    pageNextMonth () {
        this.loader = true
        this.pageOffsetMonth += 16
        this.$store.dispatch('artistModule/fetchPagesForTopArtistsMonth', this.pageOffsetMonth).then(()=> {
            this.loader = false
            window.scrollTo(0,0);
            this.clicksMonth ++;
            this.pageOffsetAltMonth += 16
        })
    }
    pageBackMonth () {
        this.loader = true
        this.pageOffsetMonth -= 16
        this.$store.dispatch('artistModule/fetchPagesForTopArtistsMonth', this.pageOffsetMonth).then(() => {
            this.loader = false
            window.scrollTo(0,0);
            this.clicksMonth --;
            this.pageOffsetAltMonth -= 16
        })
    }

    mounted() {
        window.scrollTo(0,0);
        this.$store.dispatch('artistModule/fetchTopArtists').then(() => {
            this.loader = false
        }).catch((error: any) => {
            this.loader = false
            this.error = error
        })
        this.$store.dispatch('artistModule/fetchTopArtistsMonth')
    }
}
